export default __webpack_public_path__ + "static/media/icon_z_to_a.1fa59057.svg";